import { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const initialState = {
  to: '',
  from: '',
};

export const RouterContext = createContext(initialState);

const RouterProvider = ({ children }: any) => {
  const location = useLocation();
  const [route, setRoute] = useState({
    to: location.pathname,
    from: location.pathname,
  });

  useEffect(() => {
    setRoute(prev => ({ to: location.pathname, from: prev.to }));
  }, [location]);

  return (
    <RouterContext.Provider value={route}>{children}</RouterContext.Provider>
  );
};

export default RouterProvider;
